export class RegExPattern {
    /**
     * Pattern that allows all characters.
     */
    public static readonly AllowAllCharacters = '^.*$';

    /**
     * (DEPRECATED) In the future, we are NOT going to store the dash (-) or spaces in the database.
     *
     * Please use {@link RegExPattern.PostalCode} instead which only stores the data and masks handle the special characters.
     *
     * Valid patterns for a postal code. This pattern allows:
     * - US Format: either five digits or five digits followed a hyphen (dash) and another four digits (12345 or 12345-1234)
     * - Canada Format: six alphanumeric characters with a space between the first 3 and second 3 (K1A 0B1)
     */
    public static readonly DeprecatedPostalCode =
        '^([A-Za-z0-9]{3}[ ][A-Za-z0-9]{3}|^\\d{5}|^\\d{5}-\\d{4})$';

    /**
     * Valid patterns for a postal code.
     *
     * This pattern allows:
     * US Format: either five digits (12345) or five digits followed by an optional 4 more digits (123456789). This follows the #####-#### format, but with the
     * dash removed.
     *
     * Canada Format: six alternating alphanumeric characters starting with a letter (K1A0B1). This follows the A#A #A# format,
     * but without the space between the first 3 and last 3 characters.
     */
    public static readonly PostalCode =
        '^(\\d{5}(\\d{4})?|[A-Z][0-9][A-Z][0-9][A-Z][0-9])$';

    /**
     * Valid patterns for a postal code that is masked (not raw). This is used to send information to CiviCRM.
     *
     * Background:
     * CiviCRM accepts postal codes in a specific format. CiviCRM expects the masked postal code while our DB stores the raw postal code.
     *
     * This pattern allows:
     * US Format: either five digits (12345) or five digits followed by an optional 4 more digits with a hyphen (12345-6789). This follows the #####-#### format, but with the
     * dash included.
     *
     * Canada Format: six alternating alphanumeric characters starting with a letter (K1A 0B1). This follows the A#A #A# format,
     * but with the space between the first 3 and last 3 characters.
     */
    public static readonly MaskedPostalCode =
        '^(\\d{5}(-\\d{4})?|[A-Z][0-9][A-Z] [0-9][A-Z][0-9])$';

    /**
     * A RegEx pattern to apply to an entire field - only allowing Alphanumeric characters.
     */
    public static readonly Alphanumeric = '^[a-zA-Z0-9]*$';

    /**
     * A RegEx pattern to apply to an entire field - only allowing first letter of K or W, followed by alphanumeric characters.
     */
    public static readonly CallSign = '^[KW][a-zA-Z0-9]*$';

    /**
     * A RegEx pattern to apply to an entire field - only allowing first letter of K, W, or L (lease), followed by alphanumeric characters.
     */
    public static readonly ScheduleHAssociatedCallSign = '^[KWL][a-zA-Z0-9]*$';

    /**
     * Only allows alphanumeric characters and a comma. This is used for comma-separated lists.
     */
    public static readonly AlphanumericWithComma = '^[a-zA-Z0-9,]*$';

    /**
     * A regex pattern that matches all printable ASCII characters except angle brackets ('<' or '>'), pipes ('|'), and
     * the DEL character (not to be confused with the 'delete' keyboard key).
     * This pattern enforces characters that are supported by EBF, prevents characters that could be used for injection attacks ('<' and '>'), and
     * ensures that no pipes ('|') are used, which will interfere with EBF operations that rely on pipe-delimited data structures.
     */
    public static readonly PrintableAsciiExceptAngleBracketsAndPipes =
        '^[\x20-\x3B\x3D\x3F-\x7B\x7D\x7E]*$';

    /**
     * A regex pattern that matches printable ASCII characters plus permitted control characters (tab, carriage return, newline)
     * excluding angle brackets ('<' or '>'), pipes ('|'), and the DEL character
     * (not to be confused with the 'delete' keyboard key).
     * This pattern enforces characters that are supported by EBF, prevents characters that could be used for injection attacks ('<' and '>'), and
     * ensures that no pipes ('|') are used, which will interfere with EBF operations that rely on pipe-delimited data structures.
     */
    public static readonly PrintableAsciiAndPermittedControlCharactersExceptAngleBracketsAndPipes =
        '^[\t\r\n\x20-\x3B\x3D\x3F-\x7B\x7D\x7E]*$';

    /**
     * An application-specific email pattern that allows:
     * {local part}@{domain with optional subdomains}.{top-level domain}
     * Examples: abc@myemail.us, a@b.c, user@mail.google.com
     */
    public static readonly EmailAddress =
        '^[^\\s@<>\\|]+@([^\\s.<>\\|@]+\\.)+[^\\s.<>\\|@]+$';

    /**
     * Only allows alphabetical characters.
     */
    public static readonly AlphabeticalCharacters = '^[A-Za-z]$';

    /**
     * Only allows numeric characters.
     */
    public static readonly NumericOnly = '^\\d+$';

    /**
     * Only allows numeric characters and a comma. This is used for comma-separated number lists.
     */
    public static readonly NumericOnlyWithComma = '^[\\d,\n]+$';

    public static readonly MatchAnyStringIncludingEmpty = '^.*$';
}
